import ShopOrderModelBase from '../_generated/modelBases/shop-order-model-base';

export default class ShopOrderModel extends ShopOrderModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
